import Vue from 'vue'
import Router from 'vue-router'
import Parent from './views/Parent.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/:lang',
    name: 'parent',
    component: Parent,
    children: [
        {
          path: '/',
          name: 'home',
          component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
        },
        {
          path: 'contacto',
          name: 'contacto',
          component: () => import(/* webpackChunkName: "contacto" */ './views/Contacto.vue')
        },
        {
          path: 'eventos',
          name: 'eventos',
          component: () => import(/* webpackChunkName: "eventos" */ './views/Eventos.vue')
        },
        {
          path: 'paisaje',
          name: 'paisaje',
          component: () => import(/* webpackChunkName: "paisaje" */ './views/Paisaje.vue')
        },
        {
          path: 'acuarela',
          name: 'acuarela',
          component: () => import(/* webpackChunkName: "acuarela" */ './views/Acuarela.vue')
        },
        {
          path: 'interiores',
          name: 'interiores',
          component: () => import(/* webpackChunkName: "interiores" */ './views/Interiores.vue')
        },
        {
          path: 'biografia',
          name: 'biografia',
          component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        }
    ]
  },{
    path: '*',
    redirect: '/es'
  }]
})
